$(document).ready(function () {
    const carga = (el) => {
        el.addClass("cargado");
    };
    setTimeout(() => {
        $(".hero .contenido-hero").addClass("visible");
    }, 1000);

    $(window).on("scroll", () => {
        var $maxScroll = $(window).height() + 100;
        var $maxScale = 1.5;
        var $x = $(window).scrollTop() / 6000 + 1;
        if ($(window).scrollTop() > $maxScroll) $x = $maxScale;
        $(".hero .background").css({
            transform: "scale(" + $x + "," + $x + ")",
        });

        /* 	if (
            $(window).scrollTop() >=
                $(".ambiente").offset().top - $(window).height() / 2 &&
            !$(".ambiente").hasClass("cargado")
        ) {
            carga($(".ambiente"));
            $(".ambiente .container").slideDown();
        } */

        if (
            $(window).scrollTop() >=
            $(".caracteristicas").offset().top - $(window).height() / 2 &&
            !$(".caracteristicas").hasClass("cargado")
        ) {
            carga($(".caracteristicas"));
        }
        /*
        if (
            $(window).scrollTop() >=
            $(".disenio").offset().top - $(window).height() / 2
        ) {
            $(".disenio .contenido").slideDown();
        } */

        $(".parallax").paroller();
    });

    $("header").slideDown(() => {
        $(".hero .container").fadeIn();
    });

    $(".modelos .img-mapeada").mapify({
        popOver: {
            content: function (zone) {
                var top = $(".mapify-svg .mapify-hover").offset().top;
                var html_popup =
                    "<strong>" + zone.attr("data-title") + "</strong>";
                return html_popup;
            },
            delay: 0.7,
            margin: "auto",
            height: "60px",
            width: "200px",
        },
    });
    $(".area-modelo").on("click", function (event) {
        event.preventDefault();
        var id = $(this).data("id");
        $("#" + id).modal("show");
    });

    $("#masterplan .img-masterplan").mapify({
        popOver: {
            content: function (zone) {
                var top = $(".mapify-svg .mapify-hover").offset().top;
                var html_popup =
                    "<strong>" + zone.attr("data-title") + "</strong>";
                return html_popup;
            },
            delay: 0.7,
            margin: "auto",
            height: "80px",
            width: "240px",
        },
    });
    $(".area-masterplan").on("click", function (event) {
        const title = $(this).data("title");
        const image = $(this).data("image");

        $.fancybox.open(
            [
                {
                    src: image,
                    opts: {
                        caption: title,
                        // thumb: "1_s.jpg",
                    },
                },
            ],
            {
                loop: false,
            }
        );
    });

    // setTimeout(() => {
    // const padre = document.getElementById("getElementsByTagName");
    $("#poliforma_masterplan area").each(function (key, item) {
        const cords = $(this).attr("coords");
        console.log(`cords`, cords);
        $($("#masterplan").find("polygon")[key])
            .addClass("mapify-polygon")
            .attr("points", cords);
    });
    // }, 5000);

    /* $("#modal-ollagua, #modal-nahuen").on("shown.bs.modal", function(event) {
        $(".modal .plantas")
            .slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                dots: true,
                arrows: false,
            })
            .fadeIn();
    });
 */
    $("#modal-ollagua, #modal-nahuen").on("hidden.bs.modal", function (event) {
        $(".modal .plantas").slick("unslick").fadeOut();
    });

    $(".cotizar").on("click", function () {
        $(".modal").modal("hide");

        const $toElement = $(".formulario");

        if ($toElement.length) {
            $([document.documentElement, document.body]).animate(
                {
                    scrollTop: $toElement.offset().top,
                },
                1000
            );
        }

        return false;
    });

    $("#terminaciones .img-cocina").mapify({
        popOver: {
            content: function (zone) {
                var top = $(".mapify-svg .mapify-hover").offset().top;
                var html_popup =
                    "<strong>" + zone.attr("data-title") + "</strong>";
                return html_popup;
            },
            delay: 0.7,
            margin: "auto",
            height: "80px",
            width: "240px",
        },
    });

    $("#terminaciones .img-banio").mapify({
        popOver: {
            content: function (zone) {
                var top = $(".mapify-svg .mapify-hover").offset().top;
                var html_popup =
                    "<strong>" + zone.attr("data-title") + "</strong>";
                return html_popup;
            },
            delay: 0.7,
            margin: "auto",
            height: "auto",
            width: "240px",
        },
    });

    $("#terminaciones .boton").on("click", function (e) {
        e.preventDefault();
        const target = $(this).attr("href");
        $("#terminaciones .activo").removeClass("activo");
        $(target).addClass("activo");
        $(this).addClass("activo");
    });

    /* $("#terminaciones")
        .find('a[aria-controls="cocina"]')
        .on("shown.bs.tab", function (event) {
            $("#terminaciones .img-cocina").mapify({
                popOver: {
                    content: function (zone) {
                        var top = $(".mapify-svg .mapify-hover").offset().top;
                        var html_popup =
                            "<strong>" + zone.attr("data-title") + "</strong>";
                        return html_popup;
                    },
                    delay: 0.7,
                    margin: "auto",
                    height: "80px",
                    width: "240px",
                },
            });
        });

    $("#terminaciones")
        .find('a[aria-controls="banio"]')
        .on("shown.bs.tab", function (event) {
            $("#terminaciones .img-banio").mapify({
                popOver: {
                    content: function (zone) {
                        var top = $(".mapify-svg .mapify-hover").offset().top;
                        var html_popup =
                            "<strong>" + zone.attr("data-title") + "</strong>";
                        return html_popup;
                    },
                    delay: 0.7,
                    margin: "auto",
                    height: "auto",
                    width: "240px",
                },
            });
        }); */
});

require("../modal_promocion");
